import CryptoJS from "crypto-js";

const settingEncryption = (data, password) => {
  return CryptoJS.AES.encrypt(
    JSON.stringify(data),
    password
  ).toString();
};

export default settingEncryption;